import { IConfigurations } from '@epicuro-next/platform/configuration';

export const DAB_FEATURE_NAME = 'dab';

/**
 * configuration keys for this module
 */
export enum DabConfigurationKeys {
  DabTurned = 'dab-turned',
  UseLegacyAggregationApi = 'use-legacy-aggregation-api',
  InboundDetailsTurnedOn = 'inbound-details-turned-on',
}

/**
 * Configuration return types and default values for this module
 */
export interface DabStateConfigurations
  extends IConfigurations<DabConfigurationKeys> {
  [DabConfigurationKeys.DabTurned]: boolean;
  [DabConfigurationKeys.UseLegacyAggregationApi]: boolean;
  [DabConfigurationKeys.InboundDetailsTurnedOn]: boolean;
}
